var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrhodtUnits(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.256,
    height: 37.992,
    viewBox: "0 -1391 3826.2 2099",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "drhodt_units_svg__a",
    d: "M329 409q44 44 100 44 30 0 43-19t13-38q0-14-9-25t-27-11q-33 0-37 30-2 14 3 21 0 1 1 3v1q-28-3-53-22-8-5-8-7 0-1 4-5t9-12 11-18 9-26 4-33q0-62-49-105t-121-44q-50 0-99 28-11-18-11-38 0-35 26-52 9-6 17-6t72-2q84-1 108-6 61-9 96-41 39-39 39-98 0-67-78-103-60-31-142-31-83 0-143 31-78 35-78 100 0 36 21 60t42 33l11 6q-36 31-36 84 0 47 29 85-44 44-44 99 0 63 50 106t121 44q51 0 95-26l11-7zm-30-66q-5 28-26 44t-52 17q-29 0-50-16t-26-45q-3-17-3-51 0-44 7-65t30-35q17-10 43-10 22 0 38 7t23 18 11 20 5 15q3 16 3 50t-3 51zM403-75q0 25-14 41t-41 23-49 9-54 2h-27q-67 0-80-6-20-9-31-28T95-74q0-10 6-23t21-30 48-28 80-12q69 0 111 28t42 64z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "drhodt_units_svg__b",
    d: "M423 750q9 0 15-6t6-14q0-5-173-482T92-240q-7-10-17-10-7 0-13 5t-6 14q0 10 174 488t177 483q4 10 16 10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "drhodt_units_svg__c",
    d: "M94 250q0 69 10 131t23 107 37 88 38 67 42 52 33 34 25 21h17q14 0 14-9 0-3-17-21t-41-53-49-86-42-138-17-193 17-192 41-139 49-86 42-53 17-21q0-9-15-9h-16l-28 24q-94 85-137 212T94 250z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "drhodt_units_svg__d",
    d: "M41 46h14q39 0 47 14v62q0 17 1 39t0 42v66q0 35-1 59v23q-3 19-14 25t-45 9H25v23q0 23 2 23l10 1q10 1 28 2t37 2q17 1 36 2t29 3 11 1h3v-40q0-38 1-38t5 5 12 15 19 18 29 19 38 16q20 5 51 5 15 0 28-2t23-6 19-8 15-9 11-11 9-11 7-11 4-10 3-8l2-5 3 4 6 8q3 4 9 11t13 13 15 13 20 12 23 10 26 7 31 3q126 0 137-113 1-7 1-139v-86q0-38 2-45t11-10q21-3 49-3h16V0h-8l-23 1q-24 1-51 1t-38 1Q596 3 587 0h-8v46h16q61 0 61 16 1 2 1 138-1 135-2 143-6 28-20 42t-24 17-26 2q-45 0-79-34-27-27-34-55t-8-83V108q0-30 1-40t3-13 9-6q21-3 49-3h16V0h-8l-24 1q-23 1-50 1t-38 1Q319 3 310 0h-8v46h16q61 0 61 16 1 2 1 138-1 135-2 143-6 28-20 42t-24 17-26 2q-45 0-79-34-27-27-34-55t-8-83V108q0-30 1-40t3-13 9-6q21-3 49-3h16V0h-8l-23 1q-24 1-51 1t-38 1Q42 3 33 0h-8v46h16z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "drhodt_units_svg__e",
    d: "M127 463q-27 0-42 17t-16 44q0 55 48 98t116 43q35 0 44-1 74-12 113-53t40-89q0-52-34-101t-94-71l-3-2q0-1 9-3t29-9 38-21q82-53 82-140 0-79-62-138T238-22q-80 0-138 43T42 130q0 28 18 45t45 18q28 0 46-18t18-45q0-11-3-20t-7-16-11-12-12-8-10-4-8-3l-4-1q51-45 124-45 55 0 83 53 17 33 17 101v20q0 95-64 127-15 6-61 7l-42 1-3 2q-2 3-2 16 0 18 8 18 28 0 58 5 34 5 62 42t28 112v8q0 57-35 79-22 14-47 14-32 0-59-11t-38-23-11-12h3q3-1 8-2t10-5 12-7 10-11 8-15 3-20q0-22-14-39t-45-18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "drhodt_units_svg__f",
    d: "M295 316q0 40-27 69t-78 29q-36 0-62-13-30-19-30-52-1-5 0-13t16-24 43-25q18-5 44-9t44-9 32-13q17-8 33-20t32-41 17-62q0-62-38-102T198-10h-8q-52 0-96 36l-8-7-9-9Q71 4 65-1L54-11H42q-3 0-9 6v137q0 21 2 25t10 5h9q12 0 16-4t5-12 7-27 19-42q35-51 97-51 97 0 97 78 0 29-18 47-20 24-83 36t-83 23q-36 17-57 46t-21 62q0 39 17 66t43 40 50 18 44 5h11q40 0 70-15l15-8 9 7q10 9 22 17h12q3 0 9-6V310l-6-6h-28q-6 6-6 12z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "drhodt_units_svg__g",
    d: "M60 749l4 1h22l28-24q94-85 137-212t43-264q0-68-10-131T261 12t-37-88-38-67-41-51-32-33-23-19l-4-4H63q-3 0-5 3t-3 9q1 1 11 13Q221-64 221 250T66 725q-10 12-11 13 0 8 5 11z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-mml-node": "math",
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("g", {
    "data-mml-node": "msup"
  }, /*#__PURE__*/React.createElement("g", {
    "data-mml-node": "mtext",
    transform: "matrix(1 0 0 -1 417.6 0)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#drhodt_units_svg__a"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#drhodt_units_svg__b",
    transform: "translate(500)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#drhodt_units_svg__c",
    transform: "translate(1000)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#drhodt_units_svg__d",
    transform: "translate(1389)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#drhodt_units_svg__e",
    "data-mml-node": "mn",
    transform: "matrix(.707 0 0 -.707 2639.6 -477.1)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-mml-node": "mtext",
    transform: "matrix(1 0 0 -1 3043.2 0)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#drhodt_units_svg__f"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#drhodt_units_svg__g",
    transform: "translate(394)"
  })))));
}
export default __webpack_public_path__ + "04503c96f2780151b42c7644578b1f76.svg";
export { SvgDrhodtUnits as ReactComponent };